export function normalizeString(string) {
    if (string !== null && string !== undefined && string !== '') {
        return string.replace(/[^A-Z0-9]+/ig, "_").toLowerCase();
    }
    return "";
}

/**
* decode with try-catch
*/
export function json_decode(elem) {
    try {
        return JSON.parse(elem);
    } catch (e) {
        return elem;
    }
}

/** 
 * decode flyer URL
 */
export function getFlyerLink(flyer, backendUrl) {
    if (flyer != null) {
        flyer = json_decode(flyer);
        if (typeof flyer === "object") {
            return backendUrl + flyer.path;
        }
        else {
            flyer = flyer.charAt(0) != "/" ? "/" + flyer : flyer;
            return backendUrl + flyer;
        }
    }
    return null;
}

/**
 * get the file path from a json object
 */
export function getFilePath(file) {
    try {
        var elem = json_decode(file);
        if (typeof elem === "object") {
            /*it's an object with copyright etc.*/
            return elem.path;
        }
        else {
            /*it's an old style image*/
            return file;
        }
    } catch (e) {
        console.log(e);
        return file;
    }
}

export function getFieldValues(content, tname) {
    if (content != null && Object.prototype.hasOwnProperty.call(content, 'fieldTypes') && content.fieldTypes != null) {
        /*find a specific field*/
        for (var i = 0; i < content.fieldTypes.length; i++) {
            var field = content.fieldTypes[i];
            if (Object.prototype.hasOwnProperty.call(field, 'technical_name') && field.technical_name == tname) {
                if (field.value != null && Array.isArray(field.value) && field.value.length == 1) {
                    return field.value[0];
                }
                return field.value;
            }
        }
    }
    return null;
}

export function getBasicFilters(structuredFilters) {
    var filters = [];
    if (structuredFilters !== null) {
        for (var i = 0; i < structuredFilters.length; i++) {
            var blub = structuredFilters[i];
            if (structuredFilters[i].type == "depender") {
                var gna = {};
                gna.field_type_id = blub.field_type_id;
                gna.label = blub.label;
                gna.options = []
                for (var j = 0; j < blub.options.length; j++) {
                    gna.options.push({ label: blub.options[j].label, value: blub.options[j].label });
                }
                filters.push(gna);
            }
            else {
                filters.push(blub);
            }
        }
    }
    return filters;
}

/*check if an array of booleans contains one that is true ...*/
export function hasErrors(objectOfBooleans) {
    for (const [key, value] of Object.entries(objectOfBooleans)) {
        if (value == true) {
            return true;
        }
    }
    return false;
}


/*changes the route-query*/
export function changeRouteQuery(route, query) {
    history.pushState({}, null,
        route.path +
        '?' +
        Object.keys(query)
            .map(key => {
                return (encodeURIComponent(key) + '=' + encodeURIComponent(query[key]))
            })
            .join('&')
    )
}



/**
 * a function that receives a stringified map that was converted to an array as a url-query and converts it back into a map
 */
export function argsFilterMapToJSMap(args) {
    var filters = null;
    if (isset(args)) {
        /*decode them*/
        filters = decodeURIComponent(args);
        /*this should give us something better than a string*/
        filters = JSON.parse(filters);
    }

    var filterMap = new Map();
    if (isset(filters) && filters.length > 0) {
        for (var i = 0; i < filters.length; i++) {
            filterMap.set(filters[i][0], filters[i][1]);
        }
        return filterMap;
    }
    return null;
}

export function getFirstFieldValue(content, tname) {
    var values = getFieldValues(content, tname);
    if (Array.isArray(values) && values.length > 0) {
        return values[0];
    }
    return values;
}

export function getAllowedFieldValues(content, tname) {
    if (content != null && Object.prototype.hasOwnProperty.call(content, 'fieldTypes') && content.fieldTypes != null) {
        /*find a specific field*/
        for (var i = 0; i < content.fieldTypes.length; i++) {
            var field = content.fieldTypes[i];
            return getAllowedValuesFromFieldTypes(field);
        }
    }
    return null;
}

export function getAllowedValuesFromFieldType(fieldType) {
    if (Object.prototype.hasOwnProperty.call(fieldType, 'field_type_values')) {
        var allowed = Array();
        /*we need only the allowed values*/
        for (var j = 0; j < fieldType.field_type_values.length; j++) {
            allowed.push(fieldType.field_type_values[j].allowed_value);
        }
        return allowed;
    }
    return null
}

export function getFilterFields(content) {
    var fields = [];
    if (content != null && Object.prototype.hasOwnProperty.call(content, 'fieldTypes') && content.fieldTypes != null) {
        /*find a specific field*/
        for (var i = 0; i < content.fieldTypes.length; i++) {
            var field = content.fieldTypes[i];
            if (Object.prototype.hasOwnProperty.call(field, 'type')) {
                if (field.type === 'select' || field.type === 'multiselect' || field.type === 'expandable_multiselect' || field.type === 'apps') {
                    fields.push(field);
                }
            }
        }
    }
    return fields.length > 0 ? fields : null;
}

export function getStructuredFilters(contentType) {
    var filters = [];
    var structuredFilters = [];
    var filterFields = getFilterFields(contentType);
    /*iterate through those fields*/
    if (filterFields !== null) {

        for (var i = 0; i < filterFields.length; i++) {
            if (filterFields[i].dependencySettings == null) {
                var entity = {};
                entity.field_type_id = filterFields[i].id;
                entity.label = filterFields[i].name;

                if (Object.prototype.hasOwnProperty.call(filterFields[i], 'type') && filterFields[i].type == "apps") {
                    /*the id of the current app*/
                    var values = "2";
                }
                else {
                    var values = getAllowedValuesFromFieldType(filterFields[i]);
                }

                var dependees = getDependees(filterFields[i], values, filterFields);
                if (dependees !== null && dependees.length > 0) {
                    entity.type = "depender";
                    entity.options = dependees;
                }
                else {
                    entity.type = "normal";
                    entity.options = createSelectOptions(values);
                }

                if (Object.prototype.hasOwnProperty.call(filterFields[i], 'type') && filterFields[i].type == "apps") {
                    for (var j = 0; j < entity.options.length; j++) {
                        var gna = entity.options[j];
                        filters.push(gna);
                    }
                }
                else {
                    filters.push(entity);
                }
            }
        }
    }

    return filters;
}


export function getDependees(forFieldType, forFieldTypeValues, fromFieldTypesArray) {
    var dependees = [];
    for (var i = 0; i < fromFieldTypesArray.length; i++) {
        if (fromFieldTypesArray[i].dependencySettings !== null && fromFieldTypesArray[i].dependencySettings.dependend_on == forFieldType.id && forFieldTypeValues.includes(fromFieldTypesArray[i].dependencySettings.action_value)) {
            /*yes - we found a dependee*/
            var entity = {};
            entity.field_type_id = fromFieldTypesArray[i].id;

            if (Object.prototype.hasOwnProperty.call(forFieldType, 'type') && forFieldType.type == "apps") {
                entity.label = fromFieldTypesArray[i].name;
            }
            else {
                entity.label = fromFieldTypesArray[i].dependencySettings.action_value;
            }

            var subValues = getAllowedValuesFromFieldType(fromFieldTypesArray[i]);
            var subDependees = getDependees(fromFieldTypesArray[i], subValues, fromFieldTypesArray);
            if (subDependees.length == 0) {
                entity.type = "normal";
                entity.options = createSelectOptions(subValues);
            }
            else {
                entity.type = "depender";
                entity.options = subDependees;
            }
            dependees.push(entity);
        }
    }
    return dependees;
}

export function createSelectOptions(values) {
    if (values !== null && Array.isArray(values) && values.length > 0) {
        var options = [];
        for (var i = 0; i < values.length; i++) {
            options.push({ label: values[i], value: values[i] });
        }
        return options;
    }
    return null;
}

export function shortenUrl(url) {
    if (url != null) {
        return url.length > 35 ? url.substring(0, 35) + '...' : url;
    }
}

export function shortenString(str, length) {
    if (str != null) {
        return str.length > length ? str.substring(0, length) + '...' : str;
    }
}

export function parseTravelTime(timeInMilliSeconds) {
    var hours = null;
    var minutes = null;
    var totalTime = null;
    var timeInMinutes = timeInMilliSeconds / 60000;
    if (timeInMinutes > 60) {
        hours = Math.round(timeInMinutes / 60);
        minutes = timeInMinutes - (hours * 60);
        if (minutes <= 0) {
            totalTime = hours + ' h';
        }
        else {
            totalTime = hours + ' h ' + Math.round(minutes) + ' min';
        }
    }
    else {
        minutes = timeInMinutes;
        totalTime = Math.round(minutes) + ' min';
    }
    return totalTime;
}



export function smartSubStr(str, len) {
    var temp = str.substr(0, len);
    if (temp.lastIndexOf('<') > temp.lastIndexOf('>')) {
        temp = str.substr(0, 1 + str.indexOf('>', temp.lastIndexOf('<')));
    }
    return temp;
}

export function showLoader(loader) {
    loader = this.$loading.show({
        container: this.fullPage ? null : this.$refs.formContainer,
        canCancel: true,
        color: "#007BFF",
        loader: 'dots',
        opacity: 0.7,
        height: 128,
        width: 128,
        onCancel: this.onCancel,
    });
    return loader;
}


export function hideLoader(loader) {
    loader.hide();
    return loader;
}


/**
 * sorts a given array of objects case-insensitive alphabetically and considering a certain locale  
 */
export function sortByProperty(objects, property, langcode) {
    objects.sort(function (a, b) {
        return a[property].toLowerCase().localeCompare(b[property].toLowerCase(), langcode);
    });
    return objects;
}


/**
 * get a placeholder image if no other image is given
 */
export function getPlaceholderImage(category = null) {
    /*we pack all the images in an array so we can return a random one*/
    var images = [
        "/assets/categories/bildungwissenschaft_default.png",
        "/assets/categories/kunstgalerie_default.png",
        "/assets/categories/musiktanz_default.png",
        "/assets/categories/cafesbarclub_default.png",
        "/assets/categories/filmmedien_default.png",
        "/assets/categories/kulturkreativraum_default.png",
        "/assets/categories/museumausstellung_default.png",
        "/assets/categories/religion_default.png",
        "/assets/categories/theateroper_default.png"];

    var image = null;

    /*if a category is given we'll look for an image matching that category*/
    if (category != null) {
        switch (category) {
            case "Bildung & Wissenschaft":
                image = images[0];
                break;
            case "Kunst & Galerien":
                image = images[1];
                break;
            case "Musik & Tanz":
                image = images[2];
                break;
            case "Cafés - Bars & Clubs":
                image = images[3];
                break;
            case "Film & Medien":
                image = images[4];
                break;
            case "Kultur- & Kreativräume":
                image = images[5];
                break;
            case "Museen & Stadtgeschichte":
                image = images[6];
                break;
            case "Religionskultur":
                image = images[7];
                break;
            case "Theater & Oper":
                image = images[8];
                break;
            default:
                image = images[Math.floor(Math.random() * images.length)];
                break;
        }
    }

    if (image == null) {
        image = images[Math.floor(Math.random() * images.length)];
    }

    return image;
}

/**
* Extract the allowedFieldValues from a FieldTypeResource
*/
export function getAllowedValuesFromFieldTypes(data) {
    if (Object.prototype.hasOwnProperty.call(data, 'field_type_values') && data.field_type_values != null) {
        /*we'll need to extract the actual values from that array*/
        var allowedValues = [];
        for (var i = 0; i < data.field_type_values.length; i++) {
            var fTypeValueId = data.field_type_values[i].id;
            var value = data.field_type_values[i].allowed_value;
            if (value != null && value != "") {
                allowedValues.push({ 'label': value, 'value': value, 'id': fTypeValueId });
            }
        }
        return allowedValues;
    }
    return null;
}

export function mapOrder(array, order, key) {
    var map = new Map();
    var index = 0;
    var tmp;
    if (!array || !order || array.length !== order.length)
        return array;
    array.forEach(function (it) {
        map.set(it[key], index++);
    });
    order.forEach(function (it) {
        if (map.get(it) === undefined) return array;
    });
    index--;
    for (; index >= 0; index--) {
        if (array[index][key] !== order[index]) {
            tmp = array[index];
            array[index] = array[map.get(order[index])];
            array[map.get(order[index])] = tmp;
            map.set(tmp[key], map.get(order[index]));
        }
    }
    return array;
}

/**
 * checks if a varialbe has a usefull value  
 */
export function isset(variable) {
    if (variable !== null && variable !== undefined && variable !== '') {
        return true;
    }

    return false;
}

/**
 * Auto-scroll helper functions for preserving last visited item
 */

/**
 * Generate a unique filter signature based on current route and filters
 * @param {Object} route - Vue router route object
 * @param {Map} selectedFilters - Currently selected filters
 * @param {string} contentTypeId - Content type ID
 * @param {boolean} isMapView - Whether currently in map view (optional)
 * @returns {string} Unique filter signature
 */
export function getCurrentFilterSignature(route, selectedFilters, contentTypeId, isMapView = null) {
    const signature = {
        path: route.path,
        contentType: contentTypeId,
        filters: selectedFilters ? Array.from(selectedFilters.entries()) : [],
        query: { ...route.query }
    };

    // Remove dynamic parameters that shouldn't affect the signature
    delete signature.query.page;

    // Handle view mode consistently
    // If isMapView is explicitly provided, use that
    // Otherwise, determine from route query
    if (isMapView !== null) {
        if (isMapView) {
            signature.query.show = 'karte';
        } else {
            delete signature.query.show;
        }
    } else {
        // If not explicitly provided, keep the current route query as is
        // This maintains backward compatibility
    }

    return JSON.stringify(signature);
}

/**
 * Save the last visited item ID to sessionStorage
 * @param {string} itemId - ID of the clicked item
 * @param {string} filterSignature - Current filter signature
 * @param {string} contentType - Content type (e.g., 'angebot', 'ort')
 */
export function saveLastVisitedItem(itemId, filterSignature, contentType) {
    try {
        const key = `lastVisited_${contentType}`;
        const data = {
            itemId: itemId,
            filterSignature: filterSignature,
            timestamp: Date.now()
        };
        sessionStorage.setItem(key, JSON.stringify(data));
        console.log(`[AUTO-SCROLL] Saved last visited item for ${contentType}:`, {
            itemId,
            filterSignature: filterSignature ? 'exists' : 'none'
        });
    } catch (error) {
        console.warn('Failed to save last visited item:', error);
    }
}

/**
 * Attempt to scroll to the last visited item with retry mechanism
 * @param {string} contentType - Content type (e.g., 'angebot', 'ort')
 * @param {string} currentFilterSignature - Current filter signature
 * @param {number} maxAttempts - Maximum number of scroll attempts
 * @param {number} timeout - Timeout between attempts in ms
 */
export function attemptScrollToLastVisited(contentType, currentFilterSignature, maxAttempts = 50, timeout = 200) {
    try {
        const key = `lastVisited_${contentType}`;
        const savedData = sessionStorage.getItem(key);

        console.log(`[AUTO-SCROLL] Attempting scroll for ${contentType}:`, {
            key,
            savedData: savedData ? 'exists' : 'none',
            currentFilterSignature: currentFilterSignature ? 'exists' : 'none'
        });

        if (!savedData) {
            console.log(`[AUTO-SCROLL] No saved data for ${contentType}`);
            return; // No saved state
        }

        const data = JSON.parse(savedData);

        // Check if the filter signature matches (item is relevant for current filters)
        if (data.filterSignature !== currentFilterSignature) {
            console.log(`[AUTO-SCROLL] Filter signature mismatch for ${contentType}:`, {
                saved: data.filterSignature,
                current: currentFilterSignature
            });
            return; // Saved state is not relevant for current filters
        }

        const lastId = data.itemId;
        if (!lastId) {
            console.log(`[AUTO-SCROLL] No item ID found for ${contentType}`);
            return;
        }

        console.log(`[AUTO-SCROLL] Found matching item ID for ${contentType}:`, lastId);

        // Determine the appropriate selector based on content type
        let selector;
        switch (contentType) {
            case 'angebot':
                selector = `[data-angebot-id="${lastId}"]`;
                break;
            case 'ort':
                selector = `[data-ort-id="${lastId}"]`;
                break;
            case 'search':
                // For search, we need to determine the content type
                const searchContentTypeElement = document.querySelector('[data-content-type]');
                const searchContentType = searchContentTypeElement ? searchContentTypeElement.dataset.contentType : null;
                if (searchContentType === '1') {
                    selector = `[data-ort-id="${lastId}"]`;
                } else {
                    selector = `[data-angebot-id="${lastId}"]`;
                }
                break;
            default:
                selector = `[data-item-id="${lastId}"]`;
        }

        let attempts = 0;

        const tryScroll = () => {
            attempts++;
            const element = document.querySelector(selector);

            console.log(`[AUTO-SCROLL] Attempt ${attempts}/${maxAttempts} for ${contentType}:`, {
                selector,
                elementFound: !!element
            });

            if (element) {
                console.log(`[AUTO-SCROLL] Successfully found element for ${contentType}, scrolling...`);

                // Use standard scrollIntoView for reliable scrolling
                element.scrollIntoView({
                    behavior: 'smooth',
                    block: 'center',
                    inline: 'nearest'
                });

                // Add a temporary highlight effect
                element.style.transition = 'box-shadow 0.3s ease';
                element.style.boxShadow = '0 0 20px rgba(0, 123, 255, 0.5)';
                setTimeout(() => {
                    element.style.boxShadow = '';
                }, 2000);

                return; // Success, stop trying
            }

            if (attempts < maxAttempts) {
                // Element not found yet, try again
                setTimeout(tryScroll, timeout);
            } else {
                console.log(`[AUTO-SCROLL] Failed to find element after ${maxAttempts} attempts for ${contentType}`);
            }
        };

        // Start the retry mechanism
        tryScroll();

    } catch (error) {
        console.warn('Failed to scroll to last visited item:', error);
    }
}